// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1230R","rootSmall":"AddTileButton_rootSmall__2tl4d"};